<div class="pkt-form-field" [class.pkt-error-state]="!!errorMessage" [class.pkt-disabled]="disabled"
  [ngClass]="'pkt-label-' + labelPosition" [formGroup]="range">
  <label *ngIf="label" class="pkt-label" [class.pkt-label--clamp]="labelLines" [style.--pkt-label-lines]="labelLines">
    {{ label }}<span *ngIf="required" class="pkt-required">*</span>
  </label>

  <div class="pkt-input-wrapper has-suffix" (click)="!disabled && picker.open()" [matTooltip]="dateRangeTooltip" [matTooltipClass]="'multiline-tooltip'" matTooltipPosition="above">
    <mat-date-range-input class="pkt-range-input" [rangePicker]="picker" [min]="minDate" [max]="maxDate"
      [dateFilter]="dateFilter" [disabled]="disabled">
      <input matStartDate formControlName="start" [placeholder]="startPlaceholder" readonly />
      <input matEndDate formControlName="end" [placeholder]="endPlaceholder" readonly (dateChange)="onRangeInput()" />
    </mat-date-range-input>
    <mat-date-range-picker #picker [startAt]="startAt" [panelClass]="['pkt-calendar', panelClass]"></mat-date-range-picker>

    <button class="pkt-suffix-icon-btn" type="button" (click)="$event.stopPropagation(); picker.open()"
      [disabled]="disabled" tabindex="-1">
      <span class="material-symbols-outlined">calendar_month</span>
    </button>
  </div>

  <div *ngIf="hint && !errorMessage" class="pkt-hint">{{ hint }}</div>
  <div *ngIf="errorMessage" class="pkt-error-msg">
    <span class="material-symbols-outlined">error</span>{{ errorMessage }}
  </div>
</div>
